import service from "@/store/services/requests-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  request: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, request) => {
    state.request = request;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((request) => {
      commit("SET_RESOURCE", request);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((request) => {
      commit("SET_RESOURCE", request);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((request) => {
      commit("SET_RESOURCE", request);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  assign({ commit, dispatch }, { requestId, data }) {
    return service.assign(requestId, data, this.$axios);
  },

  approve({ commit, dispatch }, { requestId, data }) {
    return service.approve(requestId, data, this.$axios);
  },

  complete({ commit, dispatch }, { requestId, data }) {
    return service.complete(requestId, data, this.$axios);
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((request) => {
      commit("SET_RESOURCE", request);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  request: (state) => state.request,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((request) => ({
      id: request.id,
      name: request.name,
    }));
  },
};

const requests = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default requests;
